import { render } from "./QuestionGroups.vue?vue&type=template&id=ea4e9cae&scoped=true"
import script from "./QuestionGroups.vue?vue&type=script&lang=js"
export * from "./QuestionGroups.vue?vue&type=script&lang=js"

import "./QuestionGroups.vue?vue&type=style&index=0&id=ea4e9cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4e9cae"]])

export default __exports__